import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

const PublicDomainToolTip = () => (
    <CustomToolTip
        title="Public Domain"
        info="When a registered work is categorized as a public domain work, the registration is marked as public domain in The MLC database. Royalties are not allocated or paid to identified public domain works unless the work is registered as a unique arrangement."
        place="top"
    />
)
export default PublicDomainToolTip
